export default __webpack_public_path__ + "static/media/30.6591740f.png";